import React from 'react';
import PropTypes from 'prop-types';
import { render } from 'react-dom';
import routes from '~/apiRouter';
import messages from '~h/messages';
import Loader, { spinnerStates, spinnerPositions } from '~c/ui/Loader';
// import Input from '~c/ui/Input';
import InputPhone from '~c/ui/InputPhone';
import PassRestorationVerification from '~c/popups/PassRestorationVerification';
import { formatPhoneToNumber } from '~h/format-phone';
import openErrorMsgForm, {ErrorSender} from '~c/popups/ErrorSender';
import PopupClose from '../Close';

class PassRestoration extends React.Component {
  state = {
    phone: this.props.phone,
    spinnerState: spinnerStates.done,
    errorMessage: '',
    errorServer: '',
  };

  onRequestRestore = e => {
    e.preventDefault();
    this.setState({
      spinnerState: spinnerStates.pending,
      errorMessage: '',
    });

    // FIXE: hardcoded cookie
    // const cookie =
    //   'PHPSESSID=1gr24tki39tevsiul0462eb8g0; BITRIX_SM_LOGIN=admin; BITRIX_SM_SOUND_LOGIN_PLAYED=Y';

    const options = {
      method: 'POST',
      headers: {
        // cookie,
        'content-type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        LOGIN: formatPhoneToNumber(this.state.phone),
      }),
    };

    fetch(routes.user.code, options)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (
          json.status === 'success' ||
          json.errors[0].code === 'ERR_TIMEOUT'
        ) {
          const { phone } = this.state;
          const { onRegCompliteLocation } = this.props;

          $.magnificPopup.close();
          setTimeout(() => {
            $.magnificPopup.open({
              removalDelay: 250,
              mainClass: 'mfp-anim',
              closeOnBgClick: false,
              items: {
                src: $('#popup'),
                type: 'inline',
              },
              callbacks: {
                open() {
                  render(
                    <PassRestorationVerification
                      phone={phone}
                      onRegCompliteLocation={onRegCompliteLocation}
                    />,
                    $('#popup')[0],
                  );
                },
                close() {
                  render(<div />, $('#popup')[0]);
                },
              },
            });
          }, 500);
        }
        if (json.status === 'error') {
          this.setState({
            spinnerState: spinnerStates.done,
            errorMessage: json.errors[0].message,
          });
        }
      })
      .catch((err) => {
        const errorText = `${err.name} : ${err.message}`;
        const title = document.getElementsByTagName('h1')[0]?.innerHTML || '';
        const currentLocation = window.location.pathname;
        const error = {
          errors: errorText,
          page: `Восстановление пароля. Страница: ${title}. URL: ${currentLocation}`
        };
        this.setState({
          spinnerState: spinnerStates.done,
          errorMessage: messages.serverTimeout,
          errorServer: error,
        });
      });
  };

  render() {
    return(
      <React.Fragment>
      {this.state.errorServer ? (
        <ErrorSender error={this.state.errorServer}/>
      ) : (
        <div className="popup auth">
          <div className="popup__close-container close_auth"><PopupClose/></div>
          <p className="heading heading--2">Восстановление пароля</p>
          <form className="auth__form" action="">
            <InputPhone
              value={this.state.phone}
              data-valid={true}
              onChange={value => {
                this.setState({ phone: value });
              }}
              placeholder=""
            >
              <p className="inp__label">Моб. телефон</p>
            </InputPhone>
            <button
              type="submit"
              className="btn btn--primary"
              onClick={this.onRequestRestore}
            >
              {this.state.spinnerState === spinnerStates.done ? (
                'Далее'
              ) : (
                <React.Fragment>
                  <div className="invisible">Далее</div>
                  <Loader
                    spinnerState={this.state.spinnerState}
                    spinnerPosition={spinnerPositions.absolute}
                    className="loader--white"
                  />
                </React.Fragment>
              )}
            </button>
            {this.state.errorMessage !== '' ? (
              <div className="error error__unique error__unique--left0 error__unique--top20 error--center error--red">
                {this.state.errorMessage}
              </div>
            ) : null}
          </form>
        </div>
        )
      }
      </React.Fragment>
    );
  }
}

PassRestoration.defaultProps = {
  phone: '',
  onRegCompliteLocation: '/profile',
};

PassRestoration.propTypes = {
  phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default PassRestoration;
